<template>
    <div class="loading"  v-show="isPageLoading == true">
        <n-spin size="large" style="left:50%;top:40%; z-index:100; position:absolute"/>
    </div>
    <div class="loading"  v-show="isRobotCheck == true">
        <RobotCheckModal :isRobot="isRobotCheck"/>
    </div>
    <div class="content">
        <div style="display:none">
            <div class="breadCrumb_web">
                <n-breadcrumb separator=">">
                    <n-breadcrumb-item @click="$router.push({path: `/helpcenter/${route.params.hashcode}`})">
                        <Icon size="20">
                            <HomeOutline />
                        </Icon>
                    </n-breadcrumb-item>
                    <n-breadcrumb-item>View My Order</n-breadcrumb-item>
                </n-breadcrumb>
            </div>
            <div class="breadCrumb_mobile">
                <n-breadcrumb separator=">">
                <n-breadcrumb-item @click="$router.push({path: `/helpcenter/${route.params.hashcode}`})">
                    <Icon size="12">
                        <HomeOutline/>
                    </Icon>
                </n-breadcrumb-item>
                <n-breadcrumb-item><span style="font-size: 11px">View My Order</span></n-breadcrumb-item>
                </n-breadcrumb>
            </div>
        </div>
        <div>
            <n-grid :cols="2">
                <n-grid-item>
                    <p class="title" >Hi, {{customerName}}</p>
                </n-grid-item>
                <n-grid-item>
                    <h2 class="title_mix">REF: {{salesorderDetail.refnumber}}</h2>
                    <h2 class="title_mobile">REF: {{salesorderDetail.refnumber}}</h2>
                </n-grid-item>
                <n-grid-item>
                    <p style="font-weight:400; margin:0">How can we help you today?</p>
                </n-grid-item>
                <n-grid-item>
                    <p style="float:right; margin:0; font-size:12px" v-if="Object.keys(salesorderDetail).length !== 0">{{ salesorderCreatedTime(salesorderDetail.timeinvoiced?.date)}}</p> 
                </n-grid-item>
            </n-grid>
        </div>
        <div>
            <h1 class="sub_title">Order Enquiry</h1>

            <n-form label-placement="left" :model="customerInfo" :rules="rules" ref="formRef">
                <n-form-item path="customerEmail">
                    <n-input placeholder="please enter your email" v-model:value="customerInfo.customerEmail"/>
                </n-form-item>
                <n-form-item path="customerMobile">
                    <n-input placeholder="please enter your monile number" v-model:value="customerInfo.customerMobile"/>
                </n-form-item>
                <n-form-item path="customerMessage">
                    <n-input type="textarea" maxlength="500" show-count placeholder="Please leave your message" v-model:value="customerInfo.customerMessage" :autosize="{ minRows: 20, maxRows: 20 }" />
                </n-form-item >
                <n-space justify="end">
                        <n-button type="info" @click="submitHandler" style="background-color: #1D1F9C" attr-type="button" :disabled="isSubmitBtnLoading === true" :loading="isSubmitBtnLoading === true">Submit</n-button>
                </n-space>
            </n-form>
        </div>

        <div v-if="isResultModalShow == true">
            <n-modal
                v-model:show="isResultModalShow"
                :mask-closable="false"
                preset="card"
                title="Result"
                size="huge"
                :bordered="false"
                :style="ModalStyle()"
            >
            <div v-if="responseStatus == 'success'">
                <SuccessResult @modalClose="isResultModalShow = false"/>
            </div>
            <div v-else-if="responseStatus == 'error'">
                <ErrorResult @modalClose="isResultModalShow = false"/>
            </div>
            </n-modal>
        </div>
    </div>
</template>

<script>
import {NBreadcrumb, NBreadcrumbItem, NGrid, NGridItem, NForm, NFormItem, NInput, NSpace, NButton, NSpin, NModal} from "naive-ui";
import  {HomeOutline} from "@vicons/ionicons5"
import {Icon} from "@vicons/utils"
import {onMounted, reactive, toRefs, computed, ref } from "vue";
import {useRoute} from "vue-router";
import axios from "axios";
import SuccessResult from "../../components/result/success/Success-Result"
import ErrorResult from "../../components/result/error/Error-Result"
import {useReCaptcha} from "vue-recaptcha-v3"
import RobotCheckModal from "../../components/result/robotcheck/Robot-Check-Modal"

export default{
    name:"OrderEnquiry",
    components:{
        NBreadcrumb,
        NBreadcrumbItem,
        HomeOutline,
        Icon,
        NGrid,
        NGridItem,
        NForm,
        NFormItem,
        NInput,
        NSpace, 
        NButton,
        NSpin,
        NModal,
        SuccessResult,
        ErrorResult,
        RobotCheckModal,
    },
    setup(){

        const route = useRoute();
        // console.log(route.params)
        // const orderId = ref(route.params.hashcode)
        const formRef = ref(null)
        const salesorderDetails = reactive({
            salesorderDetail:{}
        })

        const { executeRecaptcha, recaptchaLoaded  } = useReCaptcha();

        const isPageLoading = ref(true)
        const isSubmitBtnLoading = ref(false)

        const isResultModalShow = ref(false)
        const responseStatus = ref(null)

        const isRobotCheck = ref(false)

        const customerInfo = ref({
            customerName:"",
            customerEmail:"",
            customerMobile:"",
            customerMessage:"",
        })

        const customerName = computed(()=> salesorderDetails.salesorderDetail.billpersonfullname?.split(" ")[0])


        onMounted(()=>{
            //  axios.get(`orders/${route.params.hashcode}`)
             axios.get(`https://business-api.tradedepot.co.nz/Help/getTrackInfoByHashCode?hashcode=${route.params.hashcode}`)
            .then(res => {
                
                const salesorder = res.data.data.salesorder
                salesorderDetails.salesorderDetail = salesorder
                customerInfo.value.customerName = salesorder.billpersonfullname
                customerInfo.value.customerEmail = salesorder.customeremail
                customerInfo.value.customerMobile = salesorder.billpersonmobile
            })
            .then(() => isPageLoading.value = false)
            .catch(err => {
                console.log(err)
                isResultModalShow.value = true
                responseStatus.value = 'error'
                })
        })

        const salesorderCreatedTime = (time) => {
            const hours = new Date(time).getHours()
            const timePeriod = hours >= 12? "pm" : "am"
            return new Date(time).toUTCString().substr(4,18) + timePeriod
        }

        const submitHandler = async () =>{
            isSubmitBtnLoading.value = true
            await recaptchaLoaded()
            const token = await executeRecaptcha("homepage");
            const params = new URLSearchParams();
            params.append('recaptchakey', token);

            formRef.value.validate((errors) => {
                if (!errors) {

                const contents = 
                    `
Customer Name: ${customerInfo.value.customerName}

Customer Email: ${customerInfo.value.customerEmail}

Customer Mobile: ${customerInfo.value.customerMobile}

Message: 

`

const footer = `

The source of above message is sent from HELP CENTER
`
                    const emailData = {
                        fromemail: "noreply@tradedepot.com",
                        toemail: "det@tradedepot.com",
                        subject: `Order enquiry - ${salesorderDetails.salesorderDetail.refnumber}`,
                        content: contents.concat(customerInfo.value.customerMessage, footer)
                    }

                    // axios.all([axios.post(`recaptcha/signup`, params), axios.post("sms/send", emailData)])
                    //   .then(axios.spread((recaptchaRes,emailRes) => {
                    //       isResultModalShow.value = true
                    //       console.log(recaptchaRes.data.score,"recaptchaRes.data.score")
                    //     if(recaptchaRes.data.score <= 0.5 && emailRes.data.code === 200){
                    //       responseStatus.value = 'success'
                    //       customerInfo.value.customerMessage = ""
                    //     }else{
                    //       responseStatus.value = 'error'
                    //     }
                    //     isSubmitBtnLoading.value = false
                    //   }))
                    //   .catch(err => {
                    //     console.err(err)
                    //     isResultModalShow.value = true
                    //     responseStatus.value = 'error'
                    //     })

                    
                    // axios.post("recaptcha/signup", params)
                    axios.post("https://help-api.tradedepot.co.nz/api/v1/recaptcha/signup", params)
                        .then(recaptchaRes => {
                            const score = recaptchaRes.data.score
                            // console.log(recaptchaRes.data)
                            if(score >= 0.5){
                                // console.log(score)
                                axios.post('sms/send',emailData)
                                    .then(emailRes => {
                                        isResultModalShow.value = true;
                                        if(emailRes.data.code === 200){
                                          responseStatus.value = 'success'
                                          customerInfo.value.customerMessage = ""
                                        }else{
                                          responseStatus.value = 'error'
                                        }
                                        isSubmitBtnLoading.value = false
                                    })
                                    .catch(emailErr => {
                                        console.err(emailErr)
                                        isResultModalShow.value = true
                                        responseStatus.value = 'error'
                                        isSubmitBtnLoading.value = false
                                    })
                            }else{
                                // console.log("robot")
                                isRobotCheck.value = true
                                isSubmitBtnLoading.value = false
                            }
                            
                        })
                        .catch(err =>{
                            console.log(err)
                            isResultModalShow.value = true
                            responseStatus.value = 'error'
                            isSubmitBtnLoading.value = false
                        })
                    
                } else {
                    console.log(errors)
                }
                })
        }

        const ModalStyle = () =>{
            if(document.body.clientWidth < 764) return "width:80%"
            if(document.body.clientWidth >= 764) return "width:500px"
        }
        return{
            route,
            formRef,
            ...toRefs(salesorderDetails),
            isPageLoading,
            isResultModalShow,
            responseStatus,
            customerName,
            customerInfo,
            salesorderCreatedTime,
            rules:{
                customerEmail:{
                    required: true,
                    validator(rule, value){
                         const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        if(!re.test(String(value).toLowerCase())) return new Error("Please enter a valid email")
                        if (!value) return new Error('Please enter your email') 
                    },
                    // message: "Please enter your email",
                    trigger: 'blur'
                },
                customerMessage:{
                    required: true,
                    message: "Please leave your message",
                    trigger: 'blur'
                }
            },
            submitHandler,
            ModalStyle,
            isSubmitBtnLoading,
            isRobotCheck
        }
    }

}
</script>

<style scoped>
.content{
  padding-top:20px
}

.loading{
  width:100%;
  height:100%;
  position: absolute;
  left:0;
  background-color: rgba(0,0,0,0.65);
  z-index:100
}

.title{
  display:inline;
  font-size: 25px;
  line-height: 20px;
  margin:30px 0;
}

.title_mix{
  font-weight: bold;
  font-size: 18px;
  margin:0;
  float:right
}

.title_mobile{
    display:none;
}

.sub_title{
    font-size:1.4em
}

.breadCrumb_mobile{
    display:none
}
@media only screen and (max-width: 1024px) {
  .title_mobile{
    display:inline;
    font-size: 15px;
    margin:0;
    float:right
  }

  .title_mix{
  display:none
  } 

  .sub-title{
    font-size: 16px
  }
  
  .sub-desc{
    font-size: 11px
  }
}

@media only screen and (max-width:425px){
  .breadCrumb_web{
    display:none
  }

  .breadCrumb_mobile{
    display:block
  }
}
</style>